import { Controller } from "@hotwired/stimulus"

// WAI-ARIA tabs: roving tabindex + arrow / Home / End from the tablist.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.show(0, { focus: false })
  }

  select(event) {
    event.preventDefault()
    const idx = this.tabTargets.indexOf(event.currentTarget)
    if (idx >= 0) this.show(idx, { focus: true })
  }

  navigateTabsFromKeyboard(event) {
    const tabs = this.tabTargets
    const fromIndex = tabs.indexOf(event.target)
    if (fromIndex < 0) return

    let nextIndex = null
    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = fromIndex >= tabs.length - 1 ? 0 : fromIndex + 1
        break
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = fromIndex <= 0 ? tabs.length - 1 : fromIndex - 1
        break
      case "Home":
        nextIndex = 0
        break
      case "End":
        nextIndex = tabs.length - 1
        break
      default:
        return
    }

    event.preventDefault()
    this.show(nextIndex, { focus: true })
  }

  show(index, { focus = true } = {}) {
    const tabs = this.tabTargets
    if (index < 0 || index >= tabs.length) return

    tabs.forEach((btn, i) => {
      const selected = i === index
      btn.setAttribute("aria-selected", selected ? "true" : "false")
      btn.tabIndex = selected ? 0 : -1
    })

    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index
    })

    if (focus) tabs[index].focus()
  }
}
